import React, { Component } from 'react';
import axios from "axios"
import EntreeStore from "../EntreeStore"
import SignaturePod from "./EntreePodSignature"
import {observer} from "mobx-react"
import { Redirect } from "react-router-dom";

export default class SignEntree extends Component {
  constructor(props) {
    super(props);
    this.validateBTN = this.validateBTN.bind(this)
    this.setPropPad = this.setPropPad.bind(this)
    this.setExpertPad = this.setExpertPad.bind(this)
    this.loadSignatures = this.loadSignatures.bind(this)
    this.setLocPad = this.setLocPad.bind(this)
    this.validateSignatures = this.validateSignatures.bind(this)
    this.state = {
      locPad: "",
      propPad: "",
      expertPad:"",
      proprietaire: "",
      locataire: "",
      expert: "",
      signed: false
    };
    this.loadSignatures()
  }
  loadSignatures(){
   axios.post("/api/v1/experts/app/entree/getSignatures",{id: EntreeStore.rdv.id}).then((data)=>{
    this.setState({
      signed: data.data.signed,
      locataire: data.data.locataire,
      expert: data.data.expert,
      proprietaire: data.data.proprietaire,
    })
   })
  }
  setPropPad(link){
    this.setState({propPad: link})
  }
  setLocPad(link){
    this.setState({locPad: link})
  }
  validateSignatures(e){
    e.preventDefault()
    axios.post("/api/v1/experts/app/entree/signEntree",{id: EntreeStore.rdv.id,locataire: this.state.locPad,proprietaire: this.state.propPad,expert: this.state.expertPad}).then((data)=>{
      this.loadSignatures()

    })
  }
  setExpertPad(link){
    this.setState({expertPad: link})
  }
  validateBTN(){
    if(this.state.locPad.length>0 && this.state.propPad.length > 0 && this.state.expertPad.length > 0){
      return (
        <div>
            <a href="" onClick={this.validateSignatures} className="btn btn-large"><i className="material-icons left">done</i>Enregistrer</a>
        </div>
        )
    }else{
      return(
          <div>
            <p className="red-text">Veuillez signer et valider</p>
          </div>
        )
    }
  }
  render() {
    return (
      <div>
      {this.state.signed ? (
          <div className="">
              <h2 className="center">L'expertise a bien été signée</h2>
              <div className="row">
                  <div className="col s4">
                    <h3 className="center">locataire</h3>
                    <img src={this.state.locataire} alt="" className="responsive-img"/>
                  </div>
                  <div className="col s4">
                    <h3 className="center">proprietaire</h3>
                    <img src={this.state.proprietaire}  alt="" className="responsive-img"/>
                  </div>
                  <div className="col s4">
                    <h3 className="center">expert</h3>
                    <img src={this.state.expert}  alt="" className="responsive-img"/>
                  </div>
              </div>
              <h2 className="center">Une erreur ? Vous pouvez resigner ci-dessous</h2>
          </div>
        ) : (
          <div>

            <h1 className="center">Veuillez signer la fin de l'expertise</h1>
          </div>
        )}
      <div className="row">
        <div className="col s4">
        <h2 className="center">Propriétaire</h2>
          <SignaturePod sign={this.setPropPad}/>
        </div>
        <div className="col s4">
        <h2 className="center">Locataire</h2>
          <SignaturePod sign={this.setLocPad}/>

        </div>
        <div className="col s4">
          <h2 className="center">Expert</h2>
          <SignaturePod sign={this.setExpertPad}/>
        </div>

      </div>
      <div className="container">
        <div className="row">
          <div className="col s4 offset-s8">
          {this.validateBTN()}
          </div>
        </div>
      </div>
      </div>
    );
  }
}

